export default (input, inputId) => {
	if (!input || !inputId) {
		return;
	}

	input.addEventListener(
		'focus',
		() => {
			import('./autocompleteCompanyInput').then(({ default: autocompleteCompanyInput }) => {
				autocompleteCompanyInput(input, inputId);
			});
		},
		{ once: true }
	);

	input.addEventListener('keydown', function (e) {
		if ((e.keyCode >= 48 && e.keyCode <= 90) || e.keyCode == 8 || e.keyCode == 46) {
			inputId.value = '';
		}
	});
};
